const iconSwipers = document.querySelectorAll('.icon-text__swiper')

if (iconSwipers) {
  iconSwipers.forEach(slider => {
    const swiper = new Swiper(slider, {
      slidesPerView: 2,
      spaceBetween: 24,
      navigation: {
        nextEl: '.icon-text__swiper-button-next',
        prevEl: '.icon-text__swiper-button-prev',
      },
      breakpoints: {
        768: {
          slidesPerView: 3,
        },
      },
    })
  })
}